import ranks from "../../../api/lib/job-quest-ranks.json";

export type QuestRank = keyof typeof ranks;
export type QuestStatus = "accepting" | "closed";
export type JobQuest = {
  id: number;
  questNumber: number;
  title: string;
  company: string;
  status: QuestStatus;
  rank: QuestRank;
  contractType: string;
  target: string;
  description: string;
  mission: string;
  challengeTitle: string;
  challengeDescription: string;
  objectives: string[];
  references: { title: string; url: string }[];
  requiredSkills: string[];
  preferredSkills: string[];
  requiredExperience: string;
  preferredExperience?: string;
  personalityWeight: number;
  skillWeight: number;
  selectionWeightsConfirmed: boolean;
  reward: string;
  workLocation: string;
  duration: string;
  numberOfPositions: number | null;
  deadline: string | null;
  conditionsNote: string;
  applicationRequirements: string[];
  selectionProcess: string[];
  pastAchievements: { year: number; grade: string; description: string }[];
  applicationUrl: string | null;
  contactUrl: string | null;
  isDemo: boolean;
};
export const questRanks = ranks;
export const questNumberLabel = (number: number) =>
  String(number).padStart(3, "0");
export const questPath = (number: number) => `/job-quest/quests/${number}/`;
export const questContactPath = (number?: number) =>
  `/contact/?type=job-quest${number ? `&quest=${number}` : ""}#contact`;
export function isAccepting(quest: JobQuest, now = Date.now()) {
  return (
    quest.status === "accepting" &&
    (quest.deadline === null || new Date(quest.deadline).getTime() > now)
  );
}
export function formatDeadline(value: string | null) {
  if (value === null) return "未定";
  return new Intl.DateTimeFormat("ja-JP", {
    timeZone: "Asia/Tokyo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(new Date(value));
}
